/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Create_SuccessInputs */

const en_admin_invite_codes_create_success = /** @type {(inputs: Admin_Invite_Codes_Create_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite code(s) created`)
};

const zh_admin_invite_codes_create_success = /** @type {(inputs: Admin_Invite_Codes_Create_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请码创建成功`)
};

/**
* | output |
* | --- |
* | "Invite code(s) created" |
*
* @param {Admin_Invite_Codes_Create_SuccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_create_success = /** @type {((inputs?: Admin_Invite_Codes_Create_SuccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Create_SuccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_create_success(inputs)
	return zh_admin_invite_codes_create_success(inputs)
});
export { admin_invite_codes_create_success as "admin.invite_codes.create_success" }